import React from 'react';
import { motion } from 'framer-motion';
import { contact } from '../data/site';
import { useLanguage } from '../contexts/LanguageContext';
import { useMotionPreferences } from '../hooks/useMotionPreferences';
import { GlowButton } from './motion/GlowButton';
import { fadeUp, staggerContainer, viewportOnce } from '../utils/motion';
export function CtaBanner() {
  const {
    reduced
  } = useMotionPreferences();
  const {
    t
  } = useLanguage();
  const item = fadeUp(reduced, 26);
  return <section className="relative w-full px-5 pb-28 sm:px-8" data-id="element-32" data-mp="1rbu7ls7ybatv">
      <motion.div variants={staggerContainer(0.1)} initial="hidden" whileInView="show" viewport={viewportOnce} className="relative mx-auto max-w-6xl overflow-hidden rounded-[2rem] border border-white/10 bg-navy px-6 py-16 text-center sm:px-14 sm:py-20" data-id="element-33" data-mp="1rccbnb0uutcc">
        <div className="grid-lines absolute inset-0 opacity-50" data-id="element-34" data-mp="aym7y5dne738" />
        <motion.div aria-hidden="true" animate={reduced ? undefined : {
        scale: [1, 1.2, 1],
        opacity: [0.6, 0.95, 0.6]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut'
      }} style={{
        willChange: 'transform, opacity'
      }} className="pointer-events-none absolute -left-20 -top-24 h-80 w-80 rounded-full bg-electric/30 blur-[130px]" data-id="element-35" data-mp="5x6ky7rwtqi7" />
        <motion.div aria-hidden="true" animate={reduced ? undefined : {
        scale: [1.15, 0.95, 1.15],
        opacity: [0.6, 1, 0.6]
      }} transition={{
        duration: 12,
        repeat: Infinity,
        ease: 'easeInOut'
      }} style={{
        willChange: 'transform, opacity'
      }} className="pointer-events-none absolute -right-16 -bottom-24 h-80 w-80 rounded-full bg-magenta/35 blur-[130px]" data-id="element-36" data-mp="168ok6di13u6l" />

        <div className="relative" data-id="element-37" data-mp="nk01ly70q0xz">
          <motion.h2 variants={item} className="neon-text font-display text-3xl font-black uppercase leading-[1.05] tracking-tight text-white sm:text-5xl" data-id="element-38" data-mp="ngvmw6vxfmt2">
            {t.cta.titleLines[0]}
            <br data-id="element-39" data-mp="2g87p9wfssdaw" />
            <span className="bg-gradient-to-r from-electric via-magenta to-grape bg-clip-text text-transparent" data-id="element-40" data-mp="2g8r8rhl3j9r1">
              {t.cta.titleLines[1]}
            </span>
          </motion.h2>
          <motion.p variants={item} className="mx-auto mt-5 max-w-lg text-sm leading-relaxed text-white/60 sm:text-base" data-id="element-41" data-mp="26h4oywup02co">
            {t.cta.body}
          </motion.p>
          <motion.div variants={item} className="mt-10" data-id="element-42" data-mp="2z6tt3j2p8iii">
            <GlowButton href={contact.bookingHref} lift={4} className="inline-flex items-center justify-center rounded-full bg-magenta px-12 py-5 font-display text-sm font-extrabold uppercase tracking-[0.18em] text-white shadow-glow-magenta transition-shadow duration-300 hover:shadow-[0_0_80px_-4px_rgba(236,30,156,1)]" data-id="element-43" data-mp="2z47lxkjq050t">
              {t.cta.button}
            </GlowButton>
          </motion.div>
        </div>
      </motion.div>
    </section>;
}